var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2271 11.7498H14.3105L15.1438 8.4165H12.2271V6.74984C12.2271 5.8915 12.2271 5.08317 13.8938 5.08317H15.1438V2.28317C14.8721 2.24734 13.8463 2.1665 12.763 2.1665C10.5005 2.1665 8.8938 3.54734 8.8938 6.08317V8.4165H6.3938V11.7498H8.8938V18.8332H12.2271V11.7498Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.94054e6c30a508d1c02f02ee612761ce.svg";
export { ForwardRef as ReactComponent };